/** 主页面路由 **/
export default [
    {
        path: '/route',
        name: 'Route',
        meta: {
            title: '路线',
            requireAuth: true
        }, // requireAuth 添加该字段，表示进入这个路由是需要登录的
        component: () => import('@/views/consumerAccount/consumerAccount.vue'),
    },
    {
        path: '/route/detail/:Id/:session/:mobile/',
        name: 'RouteDetail',
        meta: {
            title: '路线详情',
            requireAuth: true
        },
        component: () => import('@/views/route/routeDetail.vue'),
    },
]